export default "__VITE_ASSET__CFiZZAJ3__"